<ng-container *ngIf="state?.isActive && currentStep">

  <!-- ── Backdrop (4 panes around the spotlight) ─────────────────────────── -->
  <div class="tutorial-pane" [ngStyle]="topPaneStyle"    aria-hidden="true"></div>
  <div class="tutorial-pane" [ngStyle]="leftPaneStyle"   aria-hidden="true"></div>
  <div class="tutorial-pane" [ngStyle]="rightPaneStyle"  aria-hidden="true"></div>
  <div class="tutorial-pane" [ngStyle]="bottomPaneStyle" aria-hidden="true"></div>

  <!-- ── Spotlight ring ───────────────────────────────────────────────────── -->
  <div
    *ngIf="targetRect"
    class="tutorial-spotlight-ring"
    [ngStyle]="spotlightRingStyle"
    aria-hidden="true"
  ></div>

  <!-- ── Step card ────────────────────────────────────────────────────────── -->
  <div
    class="tutorial-card"
    [ngStyle]="cardPosition"
    role="dialog"
    aria-modal="false"
    [attr.aria-label]="'Tutorial step: ' + currentStep.title"
  >
    <!-- Header row: step counter + skip -->
    <div class="tutorial-card__header">
      <span class="tutorial-card__step-label">{{ stepLabel }}</span>
      <button
        class="tutorial-card__skip p-button-text p-button-sm"
        (click)="skip()"
        pTooltip="Dismiss this tour (you can relaunch it from the Help menu)"
        tooltipPosition="top"
        aria-label="Skip tour"
      >
        Skip
      </button>
    </div>

    <!-- Progress dots -->
    <div class="tutorial-card__dots" aria-hidden="true">
      <span
        *ngFor="let step of state!.steps; let i = index"
        class="tutorial-card__dot"
        [class.tutorial-card__dot--active]="i === state!.currentStepIndex"
      ></span>
    </div>

    <!-- Body -->
    <div class="tutorial-card__body">
      <h4 class="tutorial-card__title">{{ currentStep.title }}</h4>
      <p class="tutorial-card__text">{{ currentStep.body }}</p>
    </div>

    <!-- Footer: navigation -->
    <div class="tutorial-card__footer">
      <button
        pButton
        class="p-button-outlined p-button-sm tutorial-card__btn-prev"
        [disabled]="isFirstStep"
        (click)="prev()"
        aria-label="Previous step"
      >
        <i class="pi pi-arrow-left"></i> Prev
      </button>

      <button
        pButton
        class="p-button-sm tutorial-card__btn-next"
        (click)="next()"
        [attr.aria-label]="isLastStep ? 'Finish tour' : 'Next step'"
      >
        {{ isLastStep ? 'Done' : 'Next' }}
        <i *ngIf="!isLastStep" class="pi pi-arrow-right"></i>
        <i *ngIf="isLastStep"  class="pi pi-check"></i>
      </button>
    </div>
  </div>

</ng-container>
